/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';
import { connect } from 'react-redux';

import { getGuestQuoteId } from 'Util/Cart';
import componentLoader from 'Util/componentLoader';
import { fetchMutation } from 'Util/Request';

import PacketaQuery from '../../query/Packeta.query';
import { PacketaComponent } from './Packeta.component';

export const PacketaDispatcher = componentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    '../../store/Packeta/Packeta.dispatcher'
), 2);
/** @namespace Bodymod/Packeta/Component/Packeta/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    pachetaApi: state.ConfigReducer.packeta_key_endpoint_url,
    countryCode: state.CheckoutReducer.countryId,
    point: state.PacketaReducer.point,
    isWidget: state.PacketaReducer.isWidget
});

/** @namespace Bodymod/Packeta/Component/Packeta/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    setPacketaPoint: (point) => PacketaDispatcher.then(
        ({ default: dispatcher }) => dispatcher.setPacketaPoint(point, dispatch)
    ),
    setPacketaWidget: (isSet) => PacketaDispatcher.then(
        ({ default: dispatcher }) => dispatcher.setPacketaWidget(isSet, dispatch)
    )
});

/** @namespace Bodymod/Packeta/Component/Packeta/Container */
export class PacketaContainer extends PureComponent {
    static propTypes = {
        pachetaApi: PropTypes.string.isRequired,
        showPacketaPopUp: PropTypes.func.isRequired,
        setPacketaPoint: PropTypes.func.isRequired,
        countryCode: PropTypes.string.isRequired,
        setPacketaWidget: PropTypes.func.isRequired,
        point: PropTypes.object.isRequired,
        isWidget: PropTypes.bool.isRequired
    };

    fieldRef = createRef();

    containerFunctions = {
        showPacketaPopUp: this.showPacketaPopUp.bind(this),
        showSelectedPacketaPoint: this.showSelectedPacketaPoint.bind(this)
    };

    componentDidMount() {
        this.init();
    }

    init() {
        const { isWidget } = this.props;
        if (!isWidget) {
            this.setWidgetApi();
        }
    }

    containerProps() {
        const { point } = this.props;
        return {
            point
        };
    }

    setWidgetApi() {
        const { setPacketaWidget } = this.props;
        const pachetaApi = 'https://widget.packeta.com/v6/www/js/library.js';
        const pachetaScript = document.createElement('script');
        pachetaScript.setAttribute('src', pachetaApi);
        document.getElementsByTagName('head')[0].appendChild(pachetaScript);
        setPacketaWidget(true);
    }

    initWidget() {
        const { showSelectedPacketaPoint } = this.containerFunctions;
        const packetaApiKey = '4abce0f2de49044c';
        const Packeta = window.Packeta || {};
        const options = {};

        Packeta?.Widget?.pick(packetaApiKey, showSelectedPacketaPoint, options);
    }

    showPacketaPopUp() {
        this.initWidget();
    }

    async showSelectedPacketaPoint(point) {
        const { setPacketaPoint } = this.props;
        const cartId = getGuestQuoteId();
        try {
            const { packetaSave: { result } = {} } = await fetchMutation(
                PacketaQuery.getPacketaSaveMutation({ packetaPoint: JSON.stringify(point), cartId })
            );

            if (result && point) {
                setPacketaPoint(point);
            }
        } catch (error) {
            console.error(error);
        }
    }

    render() {
        return (
            <PacketaComponent
              { ...this.containerProps() }
              { ...this.containerFunctions }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PacketaContainer);
